export default __webpack_public_path__ + "static/media/infra_white_logo.3eb17475.svg";